import { createSlice, PayloadAction, Dispatch } from "@reduxjs/toolkit";
import type { AxiosError } from "axios";
import { AgentService } from "app/services";
import { errorMsg, successMsg } from "app/utils/MessageUtils";
import { SubAgentPayload } from "app/types/service-types/AgentTypes";
import { resetSubAgentForm } from "./subagent-form.slice";
import { fetchAllSubAgents } from "./agents-list.slice";

interface CreateSubAgentStateParams {
  body: SubAgentPayload;
  onSuccess?: () => void;
  onError?: () => void;
}

interface CreateSubAgentSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: CreateSubAgentSlice = {
  error: "",
  success: false,
  loading: false,
};

const stateSlice = createSlice({
  name: "agent/create-subagent",
  initialState,
  reducers: {
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setSuccess: (state, action: PayloadAction<boolean>) => {
      state.success = action.payload;
    },
    setError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
    },
  },
});

export const { setLoading, setSuccess, setError } = stateSlice.actions;
export default stateSlice.reducer;

export const createSubAgent =
  (params: CreateSubAgentStateParams, afterSuccess?: () => void) =>
  async (dispatch: Dispatch) => {
    try {
      dispatch(setLoading(true));

      const response = await AgentService.createSubAgent(params.body);
      const ok = response.status >= 200 && response.status < 300;

      if (ok) {
        dispatch(setSuccess(true));
        dispatch(resetSubAgentForm());    
        // Refresh agent-visible list (sub-agents). Avoid full-page reload which can
        // trigger 403s if the current screen uses the admin-only /api/agents endpoint.
        // @ts-ignore
        dispatch(fetchAllSubAgents());
        dispatch(
          successMsg(
            localStorage.getItem("i18nextLng") === "en"
              ? "Sub-agent created successfully!"
              : "Nën-agjenti u krijua me sukses!"
          )
          

        );        
        params.onSuccess?.();
        afterSuccess?.();
        dispatch(setError(""));

      } else {
        const msg = `Request failed with status ${response.status}`;
        dispatch(errorMsg(msg));
        dispatch(setError(msg));
        params.onError?.();
      }
    } catch (e) {
      const err = e as AxiosError<any>;
      const msg =
        (err.response?.data?.message as string) ||
        err.message ||
        "Something went wrong";
      dispatch(errorMsg(msg));
      dispatch(setError(msg));
      params.onError?.();
    } finally {
      dispatch(setLoading(false));
    }
  };
